import getSDK from '@nerdwallet/nw-api-sdk';
import appConfig from '@nerdwallet/app-config';
import createFeatureFlagSDK from '@nerdwallet/nw-api-sdk/feature-flags';
import abExperimentList from './ab-experiment-list';

const config = {
  applicationID: 'nerdWallet web',
  clientID: appConfig.CLIENT_ID,
  cookieDomain: appConfig.COOKIE_DOMAIN,
  identityBaseUrl: appConfig.IDENTITY_BASE_URL,
  xhrTimeout: 10000,
  abUrl: appConfig.AB_BASE_URL,
  abExperimentList,
};

const nwApiSdk = getSDK(config);

export const featureFlagSDK = createFeatureFlagSDK({
  ServiceSDK: nwApiSdk.ServiceSDK,
  featureFlagsBaseUrl: appConfig.FEATURES_FLAGS_BASE_URL,
});

export const identityProfilesToInclude = [
  nwApiSdk.IdentitySDK.PROFILES.GLOBAL_PROFILE,
];

export default nwApiSdk;
